import React from 'react';
import invariant from 'tiny-invariant';

// Excuse the short name.
// Just this once.
const ExtLink = (props) => {
  const { to, children, ...rest } = props;

  invariant(!!to, '`to` prop must be supplied to ExternalLink');
  invariant(to.startsWith('https://'), '`to` prop MUST explicitly specify HTTPS protocol.');

  return (
    <a href={to} target='_blank' rel='noopener noreferrer' {...rest}>
      {children}
    </a>
  );
};

export default ExtLink;
